angular
	.module 'App.Filter'
	.filter 'bool', ($filter, parseBool) ->
		return (input, asBoolean = false) ->
			isTrue = parseBool(input)

			return isTrue if asBoolean
			return $filter('translate')(if isTrue then 'general.yes' else 'general.no')
